/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NationsCodeInputModel } from '../../models/nations-code-input-model';
import { NationsCodeModel } from '../../models/nations-code-model';

export interface PostApiNationscodeV1Create$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: NationsCodeInputModel
}

export function postApiNationscodeV1Create$Plain(http: HttpClient, rootUrl: string, params?: PostApiNationscodeV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<NationsCodeModel>> {
  const rb = new RequestBuilder(rootUrl, postApiNationscodeV1Create$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NationsCodeModel>;
    })
  );
}

postApiNationscodeV1Create$Plain.PATH = '/private/v1/nations/Create';
